function startsWithPdf(bytes: Uint8Array): boolean {
  const limit = Math.min(bytes.length - 3, 1024);
  for (let i = 0; i <= limit; i += 1) {
    if (bytes[i] === 0x25 && bytes[i + 1] === 0x50 && bytes[i + 2] === 0x44 && bytes[i + 3] === 0x46) {
      return true;
    }
  }
  return false;
}

function decodeBase64Pdf(text: string): Uint8Array | null {
  const cleaned = text
    .replace(/^\uFEFF/, '')
    .replace(/^data:application\/pdf;base64,/i, '')
    .replace(/\s/g, '');
  if (!cleaned) return null;
  try {
    const binary = atob(cleaned);
    const out = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) {
      out[i] = binary.charCodeAt(i);
    }
    return startsWithPdf(out) ? out : null;
  } catch {
    return null;
  }
}

/** Accepts raw PDF bytes, base64 text, or JSON-wrapped base64 from the API. */
export function normalizePdfBytes(buffer: ArrayBuffer): Uint8Array {
  const bytes = new Uint8Array(buffer);
  if (startsWithPdf(bytes)) {
    return bytes.slice();
  }
  const text = new TextDecoder('utf-8').decode(bytes).trim().replace(/^\uFEFF/, '');
  const asBase64 = decodeBase64Pdf(text);
  if (asBase64) return asBase64;
  try {
    const parsed = JSON.parse(text);
    if (typeof parsed === 'string') {
      const nested = decodeBase64Pdf(parsed);
      if (nested) return nested;
    }
  } catch {
    // not JSON
  }
  return bytes.slice();
}

export function isPdfBytes(bytes: Uint8Array): boolean {
  return startsWithPdf(bytes);
}
